export default {
	er_cover_default_title: 'შესრულების მიმოხილვა',
	er_page_success_metrics: 'რა შეიცვალა ამ თვეში',
	er_page_success_metrics_range: 'რა შეიცვალა ამ პერიოდში',
	er_page_success_metrics_week: 'რა შეიცვალა ამ კვირაში',
	er_page_comparison: 'შედარებითი შეჯამება',
	er_page_period_summary: 'თვის შეჯამება',
	er_page_period_summary_range: 'პერიოდის შეჯამება',
	er_page_period_summary_week: 'კვირის შეჯამება',
	er_page_each_month: 'თითოეული თვე',
	er_page_rooms: 'ოთახები',
	er_rooms_note: 'ყველა ოთახი {month}-ში, საუკეთესო ქულა პირველი.',
	er_page_shift_comparison: 'შედარება ცვლების მიხედვით',
	er_page_shift_summary: 'ცვლების მიხედვით',
	er_page_response_time: 'საშუალო რეაგირების დრო (წთ)',
	er_page_avg_score: 'გამოცდილების ქულა',
	er_page_complaints_vs_visits: 'საჩივრები vs ვიზიტები',
	er_page_performance_trends: 'შედეგების ტენდენციები',
	er_page_complaint_drivers: 'საჩივრების მიზეზები',
	er_board_working: 'გაუმჯობესდა {month}-თან შედარებით',
	er_board_attention: 'ყურადღებას საჭიროებს {month}-თან შედარებით',
	er_board_empty: 'ამ თვეში არსებითი ცვლილებები არ არის.',
	er_board_empty_range: 'ამ პერიოდში არსებითი ცვლილებები არ არის.',
	er_board_empty_week: 'ამ კვირაში არსებითი ცვლილებები არ არის.',
	er_findings_intro: 'შედარება {month}-თან. ნაჩვენებია მხოლოდ არსებითი ცვლილებები.',
	er_verdict_improved: 'გაუმჯობესდა',
	er_verdict_watch: 'ყურადღება სჭირდება',
	er_col_metric: 'მაჩვენებელი',
	er_col_avg: 'YTD საშ.',
	er_col_lifetime_avg: 'საშ. დაწყებიდან',
	er_comparison_note: 'YTD საშუალო არის მაჩვენებელი იანვრიდან {month}-მდე.',
	er_lifetime_note: 'დაწყებიდან არის თვიური საშუალო პირველი დღიდან მონაცემებით {month}-მდე.',
	er_comparison_note_week: 'ანგარიშის კვირა შედარდება არჩეულ წინა კვირასთან.',
	er_period_only_note: 'მაჩვენებლები მხოლოდ {month}-ისთვისაა.',
	er_each_month_note: 'არჩეული პერიოდის თითოეული თვე. თვე მონაცემების გარეშე ცარიელი რჩება.',
	er_col_inc_dec: 'ცვლილება',
	er_col_complaint: 'საჩივარი',
	er_col_qty: 'რაოდ.',
	er_total: 'სულ',
	er_metric_avg_score: 'გამოცდილების ქულა',
	er_metric_avg_response_time: 'საშუალო რეაგირების დრო',
	er_metric_cleaner_arrivals: 'დამლაგებლების მოსვლა',
	er_metric_supervisor_inspections: 'სუპერვაიზერების შემოწმებები',
	er_metric_complaints_vs_visits_pct: 'საჩივრები ვიზიტებთან (%)',
	er_metric_complaints: 'საჩივრები',
	er_metric_customer_visits: 'ვიზიტები',
	er_metric_expired_slas: 'ვადაგასული SLA',
	er_unit_min: 'წთ',
	er_stat_expected_sla: 'მოსალოდნელი SLA',
	er_stat_vs_minutes: '{month}-ში {value}-თან შედარებით',
	er_stat_vs_count: '{month}-ში {value}-თან შედარებით',
	er_label_complaints: 'საჩივრები',
	er_label_visits: 'ვიზიტები',
	er_label_complaints_per_visits: 'საჩივრები / ვიზიტები',
	er_chart_ratio: 'საჩივრებისა და ვიზიტების თანაფარდობა',
	er_chart_ytd_window: 'იანვრიდან {month}-მდე.',
	er_cv_formula: 'საჩივრები გაყოფილი ტუალეტის ვიზიტებზე, პროცენტებში: ({complaints} ÷ {visits}) × 100 = {ratio}% {month}-ში.',
	er_export_kpis_title: 'რა შედის ანგარიშში',
	er_export_kpis_desc: 'ეს ყველაფერი ანგარიშშია. გამორთეთ ის, რაც არ გინდათ.',
	er_export_select_all: 'ყველას მონიშვნა',
	er_export_clear_all: 'ყველას მოხსნა',
	er_export_summary: '{report} vs {compare}',
	er_export_period_title: 'ანგარიშის პერიოდი',
	er_export_grain: 'ანგარიში',
	er_export_grain_month: 'თვე',
	er_export_grain_week: 'კვირა',
	er_export_week_starts: 'კვირა იწყება',
	er_export_week_starts_sunday: 'კვირას',
	er_export_week_starts_monday: 'ორშაბათს',
	er_export_report_month: 'ანგარიშის თვე',
	er_export_from_month: 'დან',
	er_export_to_month: 'მდე',
	er_export_period_note_range: 'ანგარიში აჯამებს ყოველ თვეს დასაწყისიდან ბოლომდე. შედარების ჩართვისას გამოიყენება წინა იმავე სიგრძის პერიოდი. წლის დასაწყისიდან მონაცემები კვლავ იანვრიდან ბოლო თვემდე ითვლება.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} vs {compare}',
	er_export_compare_range_note: 'წინა იმავე სიგრძის პერიოდი.',
	er_export_report_week: 'ანგარიშის კვირა',
	er_export_compare_month: 'შედარება',
	er_export_shift: 'ცვლა',
	er_export_shift_all: 'ყველა ცვლა',
	er_export_no_shifts: 'ამ ობიექტზე აქტიური ცვლები არ არის.',
	er_export_render_failed: 'ანგარიშის სწორად აგება ვერ მოხერხდა, ამიტომ ის არ ჩამოიტვირთა. განაახლეთ გვერდი და სცადეთ ხელახლა.',
	er_export_comparison: 'შედარება',
	er_export_include_previous: 'წინა პერიოდის ჩართვა',
	er_export_comparison_on: 'ჩართ.',
	er_export_comparison_off: 'გამორთ.',
	er_export_no_previous_data: 'ამ პერიოდამდე მონაცემები არ არის, ამიტომ შესადარებელი არაფერია.',
	er_export_compare_previous: 'წინა თვე',
	er_export_compare_previous_week: 'წინა კვირა',
	er_export_compare_last_year: 'იგივე თვე შარშან',
	er_export_no_periods: 'ანგარიშის ექსპორტისთვის ამ ობიექტს სჭირდება მინიმუმ ერთი თვის მონაცემები.',
	er_export_no_periods_week: 'ანგარიშის ექსპორტისთვის ამ ობიექტს სჭირდება მინიმუმ ერთი კვირის მონაცემები.',
	er_export_period_note: 'ჩამოთვლილია მხოლოდ თვეები მონაცემებით. წლის დასაწყისიდან მაჩვენებლები ყოველთვის იანვრიდან ანგარიშის თვემდეა.',
	er_export_period_note_week: 'ჩამოთვლილია მხოლოდ კვირები მონაცემებით. შედარება ყოველთვის უფრო ადრეულ კვირასთანაა.',
	er_export_period_note_single_week: 'ჩამოთვლილია მხოლოდ კვირები მონაცემებით.',
	er_find_response_time_title: 'საშუალო რეაგირების დრო',
	er_find_response_time_change: 'შეიცვალა {previous}-დან {current} წუთამდე ({change}).',
	er_find_avg_score_title: 'გამოცდილების ქულა',
	er_find_score_eased: 'დაეცა {previous}-დან {current}-მდე.',
	er_find_score_improved: 'გაიზარდა {previous}-დან {current}-მდე.',
	er_find_score_ytd_inline: 'ემთხვევა წლის საშუალოს: {ytd}.',
	er_find_score_ytd_inline_range: 'ემთხვევა საშუალოს იანვრიდან {endMonth}-მდე ({ytd}).',
	er_find_score_ytd_against: 'წლის საშუალო: {ytd}.',
	er_find_score_ytd_against_range: 'საშუალო იანვრიდან {endMonth}-მდე: {ytd}.',
	er_find_complaints_ratio_title: 'საჩივრებისა და ვიზიტების თანაფარდობა',
	er_find_complaints_ratio_improved: 'გაუმჯობესდა {previous}-დან {current}-მდე.',
	er_find_complaints_ratio_rose: 'შეიცვალა {previous}-დან {current}-მდე.',
	er_nar_cv_year_improved: 'საჩივრები ტუალეტის ვიზიტებთან შედარებით წლის განმავლობაში {from}-დან {to}-მდე გაუმჯობესდა.',
	er_nar_cv_year_rose: 'საჩივრები ტუალეტის ვიზიტებთან შედარებით წლის განმავლობაში {from}-დან {to}-მდე გაიზარდა.',
	er_nar_cv_moved: 'საჩივრები ტუალეტის ვიზიტებთან შედარებით {previous}-დან {current}-მდე შეიცვალა.',
	er_nar_cv_current: 'საჩივრები ტუალეტის ვიზიტებთან შედარებით არის {current}.',
	er_nar_types_total: 'საჩივრების ჯამი {total}.',
	er_nar_types_1: 'მთავარი საჩივარი: {a} ({ap}%).',
	er_nar_types_2: 'მთავარი საჩივარი: {a} ({ap}%), შემდეგ {b} ({bp}%).',
	er_nar_types_3: 'მთავარი საჩივარი: {a} ({ap}%), შემდეგ {b} ({bp}%) და {c} ({cp}%).',
	er_find_rooms_slowest: 'ოთახები ყველაზე ხანგრძლივი რეაგირების დროით ამ თვეში: {rooms}.',
	er_find_rooms_slowest_range: 'ოთახები ყველაზე ხანგრძლივი რეაგირების დროით ამ პერიოდში: {rooms}.',
	er_find_rooms_slowest_week: 'ოთახები ყველაზე ხანგრძლივი რეაგირების დროით ამ კვირაში: {rooms}.',
	er_find_rooms_lowest_score: 'ამ თვის ყველაზე დაბალი ქულის ოთახები: {rooms}.',
	er_find_rooms_lowest_score_range: 'ყველაზე დაბალი ქულის ოთახები ამ პერიოდში: {rooms}.',
	er_find_rooms_lowest_score_week: 'ამ კვირის ყველაზე დაბალი ქულის ოთახები: {rooms}.',

	er_find_so_what_ratio: 'ცვლილების უმეტესობა მოვიდა {rooms}-დან.',
	er_find_so_what_type: 'მთავარი საჩივარი: {name} ({percent}%).',
	er_hot_slowest: 'ოთახები ყველაზე ხანგრძლივი რეაგირების დროით',
	er_hot_expired_slas: 'ოთახები, რომლებმაც SLA გადააჭარბეს',
	er_hot_ratio: 'ოთახები საჩივრების მაჩვენებლის ყველაზე დიდი ცვლილებით',
	er_hot_top_type: 'ოთახები ყველაზე მეტი "{name}" საჩივრით',
	er_hot_col_room: 'ოთახი',
	er_col_response: 'რეაგირება',
	er_col_cleaners: 'დამლაგებლები',
	er_col_score: 'ქულა',
	er_chart_sla: 'SLA',
	er_hot_col_ratio: 'თანაფარდობა',
	er_hot_col_change: 'ცვლილება',
	er_hot_col_count: 'რაოდენობა',
	er_hot_empty: 'ამ თვეში ოთახის დონეზე გამორჩეული პუნქტები არ არის.',
	er_hot_empty_range: 'ამ პერიოდში ოთახის დონეზე გამორჩეული პუნქტები არ არის.',
	er_hot_empty_week: 'ამ კვირაში ოთახის დონეზე გამორჩეული პუნქტები არ არის.',
	er_cover_highlights: 'ამ თვეში',
	er_cover_highlights_range: 'ეს პერიოდი',
	er_cover_highlights_week: 'ამ კვირაში',
	er_cover_score_rose: 'გამოცდილების ქულა გაიზარდა.',
	er_cover_score_eased: 'გამოცდილების ქულა შემცირდა.',
	er_cover_response_improved: 'რეაგირების დრო გაუმჯობესდა.',
	er_cover_response_slowed: 'რეაგირების დრო გაიზარდა.',
	er_cover_ratio_fell: 'საჩივრების შეფარდება ვიზიტებთან შემცირდა.',
	er_cover_ratio_rose: 'საჩივრების შეფარდება ვიზიტებთან გაიზარდა.',
	er_export_pdf: 'დაფის PDF',
	er_export_executive: 'აღმასრულებელი ანგარიში',
	'executive-report': 'აღმასრულებელი ანგარიში',
	er_export_csv: 'CSV',
	er_export_status_title: 'ანგარიში იქმნება',
	er_export_status_fetch: 'რიცხვები იტვირთება',
	er_export_status_layout: 'გვერდები ჯდება',
	er_export_status_page: 'გვერდი {page} / {total}',
	er_footer_copyright: 'ეს ანგარიში შეიქმნა BuzzzTech სისტემის მეშვეობით.',
	er_contact_line: 'გაქვთ კითხვები ან გსურთ მონაცემების უფრო დეტალური ანალიზი? დაუკავშირდით BuzzzTech Customer Success გუნდს: {email} ან {phone}.',
};
